import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResolvedCollectedData } from './contracts'

const PATH = '/auth/kt-decision'

const enum DecisionWorkflowType {
  CAPTURE_DEVICE_DATA = 'capture-device-data'
}

@Injectable({
  providedIn: 'root',
})
export class DecisionService {

  constructor(private http: HttpClient) { }

  runDeviceDataWorkflow({ seonSession }: ResolvedCollectedData): Observable<void> {
    const payload = { data: { seonSession } }

    return this.http.post<void>(
      `${PATH}/workflows/start`,
      { workflowId: DecisionWorkflowType.CAPTURE_DEVICE_DATA, payload },
    )
  }
}
